import React, { Component } from 'react';
import Filter from './Filter';
import { FILTERS } from '../constants';

import s from './style';
import cx from 'classnames';
import { withTranslation } from 'react-i18next';

class Filters extends Component {
  setFilter = (filter) => {
    this.props.setFilter(filter);
  }

  render() {
    const {
      filter,
      areRegionsBlocked,
      areSubregionsBlocked,
      areBuildingsBlocked,
      areStreetsBlocked,
      isUserStartsSearching,
      t
    } = this.props;

    const defaultProps = {
      filter,
      onClick: this.setFilter
    };

    return (
      <div className={cx(s.filtersWrap, { [s.withResults]: isUserStartsSearching })}>
        <Filter
          name={FILTERS.ALL}
          text={t('components.searchFullscreen.filters.all')}
          {...defaultProps}
        />
        <Filter
          name={FILTERS.BUILDINGS}
          text={t('components.searchFullscreen.filters.buildings')}
          isBlocked={areBuildingsBlocked}
          {...defaultProps}
        />
        <Filter
          name={FILTERS.REGIONS}
          text={t('components.searchFullscreen.filters.areas')}
          isBlocked={areRegionsBlocked}
          {...defaultProps}
        />
        <Filter
          name={FILTERS.SUB_REGIONS}
          text={t('components.searchFullscreen.filters.neighborhoods')}
          {...defaultProps}
          isBlocked={areSubregionsBlocked}
        />
        <Filter
          name={FILTERS.STREETS}
          text={t('components.searchFullscreen.filters.streets')}
          {...defaultProps}
          isBlocked={areStreetsBlocked}
        />
      </div>
    );
  }
}

export default withTranslation()(Filters);



// WEBPACK FOOTER //
// ./src/components/SearchFullscreen/Filters/Filters.js